// Real quotes for the landing pages, from src/site/prices.json (written by scripts/fetch-prices.js
// from the public API's /pricing/calculate). Never type a price into the page copy: read it here,
// so re-running the script updates every page. A route without a quote returns null and its page
// or table row is left out.
import PRICES from '../../prices.json';

export { PRICES };

export const FETCHED_AT = PRICES.fetchedAt;
export const VEHICLES = PRICES.vehicles;
export const HOURLY = PRICES.hourly;
export const POINT_RATES = PRICES.pointRates;

// Whole dollars everywhere on the site (quotes are rounded to the nearest dollar)
export const money = (n) => `$${Math.round(n)}`;

export function route(key) {
  const r = PRICES.routes[key];
  return r && r.sedan > 0 && r.suv > 0 ? r : null;
}

export const cheapest = (r) => Math.min(r.sedan, r.suv);

// Table row for a route, or null when it has no quote.
export function row(key, label) {
  const r = route(key);
  return r ? { key, label: label || r.place, sedan: r.sedan, suv: r.suv, flatRate: r.flatRate } : null;
}

export const rows = (list) => list.map(([key, label]) => row(key, label)).filter(Boolean);

// Hourly table: one row per number of hours, from the real quotes.
export function hourlyRows() {
  if (!HOURLY) return [];
  return Object.keys(HOURLY.sedan.totals).map((h) => ({
    key: `hours-${h}`,
    label: `${h} hours`,
    sedan: HOURLY.sedan.totals[h],
    suv: HOURLY.suv.totals[h],
  }));
}

// Price label for links to a page (related rides, homepage list). Flat rates (airport <-> Manhattan)
// are fixed prices; every other price is an estimate. Pages with flat-rate rows lead with their
// lowest flat rate, e.g. the JFK page: "From $140 to Manhattan (fixed)".
export function linkPrice(page) {
  const all = page.priceTables.flatMap((t) => t.rows);
  const flat = all.filter((r) => r.flatRate);
  if (flat.length) {
    const min = money(Math.min(...flat.map((r) => r.sedan)));
    return flat.length === all.length ? `From ${min} (fixed)` : `From ${min} to Manhattan (fixed)`;
  }
  return `From ${money(Math.min(page.from.sedan, page.from.suv))} (estimate)`;
}

// "Typical drive time" text from minutes, e.g. 135 -> "about 2 h 15 min".
export function driveTime(minutes) {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `about ${h ? `${h} h` : ''}${h && m ? ' ' : ''}${m ? `${m} min` : ''}`;
}
